const apiConfig = {
  // The base URL of your Azure Functions
  // In development, you might use the local URL
  // In production, uses the environment variable set during deployment
  azureFunctionsBaseUrl: process.env.REACT_APP_AZURE_FUNCTIONS_URL || 'https://funcbkdev001.azurewebsites.net',
  
  // Determine if we're in development or production
  isProduction: process.env.NODE_ENV === 'production',
  environment: process.env.REACT_APP_ENVIRONMENT || 'dev',
  
  endpoints: {
    // Azure costs endpoint
    azureCosts: '/api/costs'
  }
};

export default apiConfig;